import { Controller } from "@hotwired/stimulus"

// Uppercases the value of a field as the user types, keeping what they see in
// sync with how discount codes are stored (the Discount model upcases on lookup).
export default class extends Controller {
  connect() {
    this.upcase()
  }

  input() {
    this.upcase()
  }

  upcase() {
    const upper = this.element.value?.toUpperCase()
    if (upper !== undefined && upper !== this.element.value) {
      this.element.value = upper
    }
  }
}
